import styled from '@emotion/styled';
import { casinoColors, mainColors, dropdownWrapper } from 'src/assets/colors';
import { fontSize } from 'src/assets/fonts-config';
import type { StylesConfig } from 'src/components/DropdownWrapper/DropdownWrapper';

export const OptionWrapper = styled('div', { label: 'OptionWrapper' })<{ isSelected?: boolean }>`
    background-color: ${(props): string =>
        props.isSelected === true ? dropdownWrapper.option.bgColorSelected : dropdownWrapper.option.bgColor};
    color: ${(props): string =>
        props.isSelected === true ? dropdownWrapper.option.txtColorSelected : dropdownWrapper.option.txtColor};
    cursor: pointer;
    display: block;
    min-height: 26px;
    border-bottom: 1px solid ${dropdownWrapper.option.borderColor};
    font-weight: 400;
    white-space: nowrap;
    vertical-align: middle;

    &:last-child {
        border-bottom: none;
    }

    &:hover {
        background-color: ${(props): string =>
            props.isSelected === true ? dropdownWrapper.option.bgColorSelected : dropdownWrapper.option.bgColorHover};
        color: ${dropdownWrapper.option.txtColorSelected};
    }
`;

export const DropdownOption = styled('div', { label: 'DropdownOption' })`
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: ${fontSize.small};
    padding: 9px 8px;
`;

export const DropdownPlaceholder = styled('div', { label: 'DropdownPlaceholder' })`
    color: ${casinoColors.white};
    font-size: ${fontSize.small};
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 10px;
    right: 20px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    pointer-events: none;
`;

export const DropdownValueLabel = styled('span', { label: 'DropdownValueLabel' })`
    color: ${casinoColors.white};
    font-size: ${fontSize.small};
`;

export const getDropdownStyles = <T, IsMulti extends boolean>(): StylesConfig<T, IsMulti> => ({
    control: (base) => ({
        ...base,
        backgroundColor: mainColors.default.transparent,
        border: `1px solid ${casinoColors.white}`,
        height: '24px',
        minHeight: '24px',
        width: '160px',
        borderRadius: 0,
        boxShadow: 'none',
        '&:hover': {
            boxShadow: 'none',
        }
    }),
    valueContainer: (base) => ({
        ...base,
        padding: '0',
        height: '24px',
    }),
    placeholder: (base) => ({
        ...base,
        color: casinoColors.white,
        fontSize: fontSize.small,
    }),
    dropdownIndicator: () => ({
        display: 'none',
    }),
    indicatorSeparator: () => ({
        display: 'none',
    }),
});
